// React
import React, {Component} from 'react';
import {withRouter} from "react-router";
import {connect} from 'react-redux';
// Components
import Alert from "@material-ui/lab/Alert";
// Translations
import {withTranslation} from "react-i18next";
// Helpers
import {isBannerShow} from "@helpers";
// Styles
import './styles.scss';

class Banner extends Component {
    handleRoutes = () => {
        const {history} = this.props;
        const platform = process.env.REACT_APP_PLATFORM;

        switch (platform) {
            case 'admin':
                history.push(`/`);
                break;
            case 'centribot':
            case 'centridesk':
                window.location.href = `${process.env.REACT_APP_URL_CENTRIMANAGER}`;
                break;
        }
    }

    handleRender = () => {
        const {t, plan} = this.props;
        const {user} = this.props.data;
        let pro_banner_condition = (plan.plan.name === 'professional_trial') ||
            (plan.plan.name === 'professional' && plan.expiration_date && user.chargebee_customer_id !== "-")
        return (
            <>
                {
                    isBannerShow(plan, user) &&
                    <div className={"platform_banner"}>
                        <Alert severity="info">
                            <span
                                dangerouslySetInnerHTML={{__html: t(`commons:header.banner.${pro_banner_condition ? 'notify_expiration' : 'notify_free_trial'}.message`, {expiration_date: plan.expiration_date})}}/>
                            <button className={"btn btn-primary"}
                                    onClick={() => this.handleRoutes()}>{t('commons:header.banner.notify_expiration.button')}</button>
                        </Alert>
                    </div>
                }
            </>
        )
    }

    render() {
        return (this.handleRender());
    }
}

const mapStateToProps = state => {
    return {
        data: state
    }
}

const connect_banner = connect(
    mapStateToProps
)(Banner);

export default withTranslation('common')(withRouter(connect_banner));